import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { media } from '../theme/base/mixins';
import { StyledParagraphComponent } from '../types';

/**
 * props:
 * - service
 */

interface ParagraphProps {
  service?: boolean;
}

type ParagraphPropsThemed = ThemeProps<Theme> & ParagraphProps;

export const Paragraph: StyledParagraphComponent<ParagraphProps> = styled.p`
  font-size: ${(props: ParagraphPropsThemed) =>
    props.service ? '1.4' : '1.8'}rem;
  line-height: 1.5;
  font-weight: 300;
  ${(props: ParagraphPropsThemed) => (props.service ? 'opacity: 0.6' : '')};
  margin: ${(props: ParagraphPropsThemed) =>
    props.theme.defaults.paragraphMargin};

  a,
  em {
    font-size: ${(props: ParagraphPropsThemed) =>
      props.service ? '1.4' : '1.8'}rem;
  }

  ${media.medium`
    font-size: ${(props: ParagraphPropsThemed) =>
      props.service ? '1.6' : '2'}rem;

    a, em {
      font-size: ${(props: ParagraphPropsThemed) =>
        props.service ? '1.6' : '2'}rem;
    }
  `};
`;
